/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./package-manager.vue?vue&type=template&id=bb9a7c4c&scoped=true&"
import script from "./package-manager.vue?vue&type=script&lang=js&"
export * from "./package-manager.vue?vue&type=script&lang=js&"
import style0 from "./package-manager.vue?vue&type=style&index=0&id=bb9a7c4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9a7c4c",
  null
  
)

export default component.exports